import { VISIT } from "../constants";
import { instance } from "../../axios";

// Get visits by study id
let getVisitsByStudy = (studyId) => {
  return (dispatch) => {
    dispatch({
      type: VISIT.VISIT_GET_ALL,
    });
    return instance({
      method: "GET",
      url: `/visit/study/${studyId}`, 
    })
      .then((results) => {
        console.log("results", results);
        dispatch({
          type: VISIT.VISIT_GET_ALL_SUCCESS,
          payload: results.data,
        });
        return results.data; 
      })
      .catch((error) => {
        dispatch({
          type: VISIT.VISIT_GET_ALL_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

// Get a single visit by id
let getVisit = (id) => {
  return (dispatch) => {
    dispatch({
      type: VISIT.VISIT_GET_ONE,
    });
    instance({
      method: "GET",
      url: `/visit/${id}`,
    })
      .then((results) => {
        dispatch({
          type: VISIT.VISIT_GET_ONE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: VISIT.VISIT_GET_ONE_FAILURE,
          payload: error,
        });
      });
  };
};

// Update a visit
let updateVisit = (body) => {
  return (dispatch) => {
    dispatch({
      type: VISIT.VISIT_UPDATE,
    });
    return instance
      .put(`/visit/${body.id}`, body)
      .then((results) => {
        dispatch({
          type: VISIT.VISIT_UPDATE_SUCCESS,
          payload: results.data,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: VISIT.VISIT_UPDATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

// Create a new visit
let createVisit = (body) => {
  return (dispatch) => {
    dispatch({
      type: VISIT.VISIT_CREATE,
    });
    return instance
      .post("/visit", body)
      .then((results) => {
        dispatch({
          type: VISIT.VISIT_CREATE_SUCCESS,
          payload: results.data,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: VISIT.VISIT_CREATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

// Delete a visit
let deleteVisit = (id) => {
  return (dispatch) => {
    dispatch({
      type: VISIT.VISIT_DELETE,
    });
    return instance
      .delete(`/visit/${id}`)
      .then((results) => {
        dispatch({
          type: VISIT.VISIT_DELETE_SUCCESS,
          payload: id,
        });
        return results.data;
      })
      .catch((error) => {
        dispatch({
          type: VISIT.VISIT_DELETE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

export {
  getVisit,
  getVisitsByStudy,
  updateVisit,
  createVisit,
  deleteVisit,
};